import { accentColor, BASIC_COLOR_SET } from 'constants/chartConstants';

import { Point } from 'highcharts';
import React, { useMemo } from 'react';

import VerticalBarChart from 'components/common/verticalBarChart/VerticalBarChart';

interface CampaignPerformanceData {
  date: string;
  numberOfImpressions: number;
  top10: number;
  average: number;
  bottom10: number;
}

interface CampaignPerformanceTrendChartProps {
  data: CampaignPerformanceData[];
}

const CampaignPerformanceTrendChart = ({
  data,
}: CampaignPerformanceTrendChartProps): React.ReactElement => {
  const categories = useMemo(
    () => data.map((performanceData, index) => `Week ${index + 1}`),
    [data]
  );

  // Prepare bar data and memoize to optimize performance
  const barData = useMemo(
    () => [
      {
        name: 'Top 10%',
        data: data.map((d) => d.top10),
        color: BASIC_COLOR_SET[0], // Green color for Top 25%
      },
      {
        name: 'Average',
        data: data.map((d) => d.average),
        color: BASIC_COLOR_SET[1], // Blue color for Average
      },
      {
        name: 'Bottom 10%',
        data: data.map((d) => d.bottom10),
        color: accentColor, // Accent color for Bottom 10%
      },
    ],
    [data]
  );

  const tooltipFormatter = (point: Point) => {
    if (point.series.name === 'Average') {
      return `<b>${point.category}</b><br/><br/>The <b>${point.series.name}</b> campaigns achieved <b>${point.y}</b> MQA Conversions per 1,000 Impressions`;
    }
    return `<b>${point.category}</b><br/><br/><b>${point.series.name}</b> campaigns achieved <b>${point.y}</b> MQA Conversions per 1,000 Impressions`;
  };

  return (
    <VerticalBarChart
      categories={categories}
      barData={barData}
      title='Campaign Performance Based on MQA Conversions per 1,000 Impressions'
      yAxisTitles={{
        barAxisTitle: 'MQA Conversions',
      }}
      max={100}
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default CampaignPerformanceTrendChart;
